// @ts-nocheck
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
} from '@mui/material';
import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as CloseIcon } from '../../../assets/Icons/lucideIcons/x.svg';

import DialogTransition from '../../Common/Transition/DialogTransition';
import ModelNetworks from '../../Common/ModelInventoryAndAssociation/Summary/ModelNetworks';
import useModelInventory from '../../../hooks/ModelInventory/useModelInventory';

const ShowModelLineageModal = ({
  open,
  handleClose,
  previewItem,
  entityType = 'ModelInventory',
  openInNewTab = false,
}) => {
  const [entityId, setEntityId] = useState(null);
  const [isEntityIdLoading, setIsEntityIdLoading] = useState(!!entityId);
  const { isEntityAvailable } = useModelInventory();

  const handleClosePreview = useCallback(() => {
    handleClose();
  }, [handleClose]);

  useEffect(() => {
    if (previewItem?.item?.id && open) {
      setIsEntityIdLoading(true);
      const rawUniqueId = previewItem?.item?.id;
      const normalizedUniqueId = rawUniqueId
        ? decodeURIComponent(rawUniqueId)
        : rawUniqueId;
      isEntityAvailable(
        {
          entityType,
          uniqueId: normalizedUniqueId,
        },
        false
      )
        .then((res) => {
          if (res?.data?.entity_id) {
            setEntityId(res?.data?.entity_id);
          }
        })
        .finally(() => {
          setIsEntityIdLoading(false);
        });
    }
  }, [previewItem?.item?.id, open, entityType]);

  return (
    <Dialog
      maxWidth="lg"
      open={open}
      onClose={handleClose}
      slots={{
        transition: DialogTransition,
      }}
    >
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          {previewItem?.title}
        </Box>
      </DialogTitle>

      <IconButton
        color="primary"
        aria-label="Close dialog"
        onClick={handleClosePreview}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon width={18} height={18} />
      </IconButton>
      <DialogContent dividers>
        <Grid
          container
          size={12}
          sx={{
            mb: 2,
            p: 1,
          }}
        >
          <Grid size={12}>
            <Box
              sx={{
                width: '100%',
                height: '60vh',
              }}
            >
              {open && (
                <ModelNetworks
                  entityId={entityId}
                  isControl={false}
                  entityType={entityType}
                  openInNewTab={openInNewTab}
                  loading={isEntityIdLoading}
                  renderContextMenuInPortal={true}
                />
              )}
            </Box>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

ShowModelLineageModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  previewItem: PropTypes.shape({
    item: PropTypes.shape({
      id: PropTypes.number,
    }),
    title: PropTypes.string,
  }).isRequired,
  entityType: PropTypes.string,
  openInNewTab: PropTypes.bool,
};

export default ShowModelLineageModal;
